import api from '@/utils/axios';
import { unwrapItem, unwrapList } from '@/utils/apiHelpers';
import type { ApiUser, UserWritePayload } from './types';

export async function listUsers(): Promise<ApiUser[]> {
  const res = await api.get('/users');
  return unwrapList<ApiUser>(res.data);
}

export async function getUser(userId: number): Promise<ApiUser> {
  const res = await api.get(`/users/${userId}`);
  return unwrapItem<ApiUser>(res.data);
}

export async function createUser(payload: UserWritePayload): Promise<ApiUser> {
  const res = await api.post('/users', payload);
  return unwrapItem<ApiUser>(res.data);
}

export async function updateUser(userId: number, payload: UserWritePayload): Promise<ApiUser> {
  const res = await api.patch(`/users/${userId}`, payload);
  return unwrapItem<ApiUser>(res.data);
}

export async function deleteUser(userId: number): Promise<void> {
  await api.delete(`/users/${userId}`);
}

export async function deactivateUser(userId: number): Promise<ApiUser> {
  const res = await api.post(`/users/${userId}/deactivate`);
  return unwrapItem<ApiUser>(res.data);
}

export async function activateUser(userId: number): Promise<ApiUser> {
  const res = await api.post(`/users/${userId}/activate`);
  return unwrapItem<ApiUser>(res.data);
}

/** Met à jour uniquement le statut en récupérant d'abord l'utilisateur complet (requis par l'API). */
export async function updateUserStatus(userId: number, status: string): Promise<ApiUser> {
  const user = await getUser(userId);
  return updateUser(userId, {
    firstnames: user.firstnames,
    lastname: user.lastname,
    phone: user.phone,
    email: user.email,
    status,
    zone_id: user.zone?.id ?? 1,
    secteur_id: user.secteur?.id ?? null,
    relay_point_id: user.relay_point_id ?? user.relay_point?.id ?? null,
    type_ids: user.types?.map((t) => t.id),
    permission_ids: user.permissions?.map((p) => p.id),
  });
}

export function getPrimaryTypeName(user: ApiUser): string {
  return user.types?.[0]?.name ?? 'client';
}
